import { createApiService } from "@/core/api/apiService";
import type { CreateFormDto, FormCapabilitiesDto, FormDto, GeneratedFormDto, UpdateFormDto } from "../types/formTypes";

export function createFormApiService() {
  const api = createApiService("forms");
  const scope = (businessId: string) => `?${new URLSearchParams({ businessId })}`;
  return {
    capabilities: (businessId: string, signal?: AbortSignal) =>
      api.get<FormCapabilitiesDto>(`capabilities${scope(businessId)}`, { signal }),
    generate: (businessId: string, prompt: string) =>
      api.post<GeneratedFormDto>(`generate${scope(businessId)}`, { prompt }),
    getAll: (businessId: string, signal?: AbortSignal) =>
      api.get<FormDto[]>(scope(businessId), { signal }),
    getById: (businessId: string, formId: string, signal?: AbortSignal) =>
      api.get<FormDto>(`${encodeURIComponent(formId)}${scope(businessId)}`, { signal }),
    create: (businessId: string, dto: CreateFormDto) =>
      api.post<FormDto>(scope(businessId), dto),
    update: (businessId: string, formId: string, dto: UpdateFormDto) =>
      api.put<FormDto>(`${encodeURIComponent(formId)}${scope(businessId)}`, dto),
    delete: (businessId: string, formId: string) =>
      api.delete<{ message: string }>(`${encodeURIComponent(formId)}${scope(businessId)}`),
  };
}

export const formApiService = createFormApiService();
